export const requestPasswordReset = async (email) => {
    try {
      let url = process.env.REACT_APP_BACKEND_URL + "/requestPasswordReset"
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify({email:email})
      });
      const result = await response.json();
      console.log(result);
    } catch (error) {
      console.log(error);
    }
  };